// export const linkFromTxHash = txHash => 'https://explorer-dev.kardiachain.io/tx/' + txHash;
export const linkFromTxHash = txHash => 'https://rinkeby.etherscan.io/tx/' + txHash;